import { Validator } from './Validator';
import { ReactError } from 'consts/ReactError';

export type FormErrors = {
	gid: string;
	pass: string;
	lastname: string;
	firstname: string;
	kana_lastname: string;
	kana_firstname: string;
	sex: string;
	birthYear: string;
	birthMonth: string;
	birthDate: string;
};

export const initialFormErrors: FormErrors = {
	gid: '',
	pass: '',
	lastname: '',
	firstname: '',
	kana_lastname: '',
	kana_firstname: '',
	sex: '',
	birthYear: '',
	birthMonth: '',
	birthDate: '',
};

export const getErrorMessage = <T>(name: string, value: T): string => {
	const validator = new Validator(value);
	switch (name) {
		case 'gid':
			return validator.require().charTypeGakkenId().end();
		case 'pass':
			return validator.charTypePassword().end();
		case 'lastname':
		case 'firstname':
			return validator.require().charTypeFullWidth(ReactError.E0007).end();
		case 'kana_lastname':
		case 'kana_firstname':
			return validator.charTypeFullWidthKana(ReactError.E0006).end();
		case 'birthYear':
		case 'birthMonth':
		case 'birthDate':
			return validator.require().end();
		case 'sex':
			return '';
		default:
			return '';
	}
};
